import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 
  
  .generated-images-holder-var35 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var35 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .text-var35 {
    position: absolute;
    width: 100%;
    padding: 0 20px;
    bottom: 30px;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #f3d400;
    font-weight: 700;
    font-family: CustomArial;
    letter-spacing: 1.6px;
    text-shadow: 1px 0 0 #f3d400;
    &--top {
      bottom: auto;
      top: 30px;
    }
    p {
      display: inline-block;
      margin: 0;
      padding: 14px 39px 16px;
      background-color: rgba(0,0,0,0.5);
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }
  .full-image-var35 {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .actual-photo-var35 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    &--top {
      top: 0;
      bottom: auto;
    }
  }
`;

export default VariationsStyles;
